package com.exura.features.plandefinition.domain.builder.plan

import com.exura.features.plandefinition.domain.model.plan.PlanType
import com.exura.features.plandefinition.domain.model.plan.TreatmentPlan

/**
 * Enhanced Treatment Plan Builder - minimal implementation, base class does all the work
 */
class TreatmentPlanBuilderNew : BasePlanBuilderNew<TreatmentPlan>(planType = PlanType.POSTPLAN) {

    override fun build(): TreatmentPlan {
        return TreatmentPlan(
            firebaseDocId = firebaseDocId(),
            title = title() ?: "",
            description = description() ?: "",
            collections = collections(),
            directSeries = directSeries(),
            imageUrl = imageUrl()
        )
    }

}

fun TreatmentPlan.toBuilder(): TreatmentPlanBuilderNew {
    val plan = this
    return TreatmentPlanBuilderNew().apply {
        setFirebaseDocId(plan.firebaseDocId)
        setTitle(plan.title)
        setDescription(plan.description)
        setCollections(plan.collections)
        setDirectSeries(plan.directSeries)
        setImageUrl(plan.imageUrl)
        markSaved()
    }
}
